export default function roomEventListener(room) {
  return store => {
    room.addEventListeners({
        room_sharenote_changeNote: e => {
            store.commit('shareNote/CHANGE_NOTE', e.data)
        }
    });
  }
}
